/**
 * type for a function that can be passed as a callback to the Array.sort
 */
export type TSortFnc<TItem> = (itemA: TItem, itemB: TItem) => number

/**
 * copies the array into a new one (prevent mutation),
 * sorts the new array using the provided sortFunction
 * and returns the result
 *
 * curried function – takes sortFunction as 1st argument, the array to be sorted as a 2nd one
 */
export const sortArray =
  <TItem>(sortFunction: TSortFnc<TItem>) =>
  (originalArray: RoA<TItem>) => {
    const sortedArray = [...originalArray]
    sortedArray.sort(sortFunction)

    return sortedArray
  }
